// src/shared/services/themes.ts
export const themeStyles: Record<string, string> = {
  Blue: "bg-blue-500 text-white border-blue-700",
  DodgerBlue: "bg-[#1E90FF] text-white border-[#1E90FF]",
  Green: "bg-green-500 text-white border-green-700",
  Purple: "bg-purple-500 text-white border-purple-700",
  Orange: "bg-orange-500 text-white border-orange-700",
  Pink: "bg-pink-500 text-white border-pink-700",
  Teal: "bg-teal-500 text-white border-teal-700",
  Yellow: "bg-yellow-400 text-black border-yellow-600",
  Indigo: "bg-indigo-500 text-white border-indigo-700",
  Cyan: "bg-cyan-500 text-black border-cyan-700",
  Amber: "bg-amber-500 text-black border-amber-700",
  Lime: "bg-lime-500 text-black border-lime-700",
  Fuchsia: "bg-fuchsia-500 text-black border-fuchsia-700",
  Rose: "bg-rose-500 text-white border-rose-700",
  Sky: "bg-sky-500 text-white border-sky-700",
  Emerald: "bg-emerald-500 text-white border-emerald-700",
  Slate: "bg-slate-600 text-white border-slate-800",
  Zinc: "bg-zinc-600 text-white border-zinc-800",
  Stone: "bg-stone-600 text-white border-stone-800",
  Neutral: "bg-neutral-600 text-white border-neutral-800",
  Light: "bg-gray-200 text-gray-800 border-gray-300 border shadow-lg",
};

export const fontColor: Record<string, string> = {
  Blue: "text-blue-500",
  Green: "text-green-500",
  Purple: "text-purple-500",
  Orange: "text-orange-500",
  Pink: "text-pink-500",
  Teal: "text-teal-500",
  Yellow: "text-yellow-400",
  Indigo: "text-indigo-500",
  Cyan: "text-cyan-500",
  Amber: "text-amber-500",
  Lime: "text-lime-500",
  Fuchsia: "text-fuchsia-500",
  Rose: "text-rose-500",
  Sky: "text-sky-500",
  Emerald: "text-emerald-500",
  Slate: "text-slate-600",
  Zinc: "text-zinc-600",
  Stone: "text-stone-600",
  Neutral: "text-neutral-600",
  DarkGray: "text-gray-800 ",
  Light: "text-gray-800",
};

export const fontStyles: Record<string, string> = {
  "Sans-serif": "font-sans",
  Serif: "font-serif",
  Monospace: "font-mono",
  Thin: "font-thin",
  "Extra Light": "font-extralight",
  Light: "font-light",
  Normal: "font-normal",
  Medium: "font-medium",
  "Semi Bold": "font-semibold",
  Bold: "font-bold",
  "Extra Bold": "font-extrabold",
  Black: "font-black",
  Italic: "italic",
  Uppercase: "uppercase",
  Lowercase: "lowercase",
  Capitalize: "capitalize",
  "Tracking Tight": "tracking-tight",
  "Tracking Wide": "tracking-wide",
  "Text Shadow": "shadow-lg",
  Underline: "underline",
  "Line-through": "line-through",
  Overline: "overline",
  "Small Caps": "tracking-widest uppercase text-xs",
  "Loose Spacing": "tracking-wider",
  "Compact Spacing": "tracking-tighter",
};

export const SlidbarThemeStyles: Record<string, string> = {
  Blue: "bg-blue-100 text-black border-blue-300",
  DodgerBlue: "bg-[#1E90FF]/10 text-black border-[#1E90FF]/50",
  Green: "bg-green-100 text-black border-green-300",
  Purple: "bg-purple-100 text-black border-purple-300",
  Orange: "bg-orange-100 text-black border-orange-300",
  Pink: "bg-pink-50 text-black border-pink-300",
  Teal: "bg-teal-100 text-black border-teal-300",
  Yellow: "bg-yellow-100 text-black border-yellow-300",
  Indigo: "bg-indigo-100 text-black border-indigo-300",
  Cyan: "bg-cyan-100 text-black border-cyan-300",
  Amber: "bg-amber-100 text-black border-amber-300",
  Lime: "bg-lime-100 text-black border-lime-300",
  Fuchsia: "bg-fuchsia-100 text-black border-fuchsia-300",
  Rose: "bg-rose-100 text-black border-rose-300",
  Sky: "bg-sky-100 text-black border-sky-300",
  Emerald: "bg-emerald-100 text-black border-emerald-300",
  Slate: "bg-slate-100 text-black border-slate-600",
  Zinc: "bg-zinc-100 text-black border-zinc-600",
  Stone: "bg-stone-100 text-black border-stone-600",
  Neutral: "bg-neutral-100 text-black border-neutral-600",
  Light: "bg-white text-gray-800 border-gray-300 border",
};
